import { Id } from 'react-toastify';

import { formatString, objectValues } from '@hsp/utilities';

import { INotification } from '@c/notifications/types';

import { Uri } from 'constants/index';
import { IResult, OperationResult } from 'types/api/common';

import { BaseHttpService } from './http/base-http.service';

class NotificationService extends BaseHttpService {
  constructor() {
    super({ endpoints: objectValues(Uri.Notification) as string[] });
  }

  deleteNotification(id: Id, cancel = false): Promise<OperationResult> {
    const url = formatString(Uri.Notification.Get, id.toString());

    return this.delete(this.defaultRequestConfig(url, cancel));
  }

  deleteNotifications(cancel = false): Promise<OperationResult> {
    const url = Uri.Notification.DeleteAll;

    return this.delete(this.defaultRequestConfig(url, cancel));
  }

  getNotification(id: Id, cancel = false): Promise<IResult<INotification>> {
    const url = formatString(Uri.Notification.Get, id.toString());

    return this.get(this.defaultRequestConfig(url, cancel));
  }

  getNotifications(cancel = false): Promise<IResult<INotification[]>> {
    const url = Uri.Notification.GetAll;

    return this.get({
      ...this.defaultRequestConfig(url, cancel),
      params: { page: -1 },
    });
  }

  readAllNotifications(cancel = false): Promise<OperationResult> {
    const url = Uri.Notification.ReadAll;

    return this.put(null, this.defaultRequestConfig(url, cancel));
  }

  readNotification(id: Id, cancel = false): Promise<OperationResult> {
    const url = formatString(Uri.Notification.Read, id.toString());

    return this.put(null, this.defaultRequestConfig(url, cancel));
  }
}

export const notificationService = new NotificationService();
